import { create } from 'zustand';

interface Toast {
  id: string;
  kind: 'success' | 'error' | 'info';
  text: string;
}

interface ToastState {
  toasts: Toast[];
  push: (kind: Toast['kind'], text: string) => void;
  dismiss: (id: string) => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (kind, text) => {
    const id = `t_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`;
    set((s) => ({ toasts: [...s.toasts, { id, kind, text }] }));
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), 4000);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export const toast = {
  success: (text: string) => useToastStore.getState().push('success', text),
  error: (text: string) => useToastStore.getState().push('error', text),
  info: (text: string) => useToastStore.getState().push('info', text),
};

export const ToastContainer = () => {
  const toasts = useToastStore((s) => s.toasts);
  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`rounded-md shadow-lifted px-4 py-2.5 text-sm max-w-sm animate-in fade-in slide-in-from-bottom-2 ${
            t.kind === 'success'
              ? 'bg-emerald-600 text-white'
              : t.kind === 'error'
                ? 'bg-rose-600 text-white'
                : 'bg-ink text-white'
          }`}
        >
          {t.text}
        </div>
      ))}
    </div>
  );
};
